import type { ModuleMigrationDef } from "@kubdee/sdk";

// #411 — vehicle-level cost center override. Nullable soft FK to
// `accounting_cost_centers.id`. Paired with the auto-fill chain in
// `resolveVehicleCostCenter()` (vehicle → branch → company.defaultCostCenterId).
export const migration: ModuleMigrationDef = {
  key: "003_add_vehicle_cost_center",
  version: "1.2.0",
  sql: `
ALTER TABLE \`fleet_vehicles\` ADD COLUMN \`cost_center_id\` text;
`,
};
